import { Params } from '@angular/router';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Product } from '@planone/bau365/util-fair-data';
import { selectRouteParams } from '@planone/shared/util-ngrx';

import { DATA_ACCESS_PRODUCTS_FEATURE_KEY, ProductsState } from './data-access-products.reducer';

import { getExhibitorId } from '../../exhibitors/entity/data-access-exhibitors.selectors';

export const getDataAccessProductsState = createFeatureSelector<ProductsState>(DATA_ACCESS_PRODUCTS_FEATURE_KEY);

export const getProductIds = createSelector(getDataAccessProductsState, (state: ProductsState) =>
  Object.keys(state.products)
);

export const getProducts = createSelector(getDataAccessProductsState, (state: ProductsState) =>
  Object.values(state.products)
);

export const getProductId = createSelector(selectRouteParams, (routerParams: Params) => {
  return typeof routerParams !== 'undefined' && routerParams['id'] != null ? routerParams['id'] : undefined;
});

export const getProductById = createSelector(
  getDataAccessProductsState,
  (state: ProductsState, props: { productId?: string }) => {
    if (props.productId && state.products && state.products[props.productId]) {
      return state.products[props.productId];
    }

    return undefined;
  }
);

export const getProductsById = createSelector(
  getDataAccessProductsState,
  getProducts,
  (state: ProductsState, products: Product[], props: { productIds: string[] }) => {
    if (props.productIds && products) {
      return products.filter((product) => props.productIds.includes(product.id));
    }
    return undefined;
  }
);

export const getProduct = createSelector(
  getDataAccessProductsState,
  getProductId,
  (state: ProductsState, productId: string) => (productId != null ? state.products[productId] : undefined)
);
export const getActiveProductLoadingState = createSelector(
  getDataAccessProductsState,
  (state: ProductsState) => state.activeProductLoading
);
export const getActiveProductError = createSelector(getDataAccessProductsState, (state: ProductsState) =>
  state.activeProductError ? state.activeProductError : undefined
);

export const getProductExhibitorProducts = createSelector(
  getDataAccessProductsState,
  getProducts,
  getExhibitorId,
  (state: ProductsState, products: Product[], exhibitorId: string) =>
    products.filter((product) => product.exhibitor_id === exhibitorId)
);

export const getProductProducts = createSelector(
  getDataAccessProductsState,
  getProduct,
  (state: ProductsState, openProduct?: Product) =>
    Object.values(state.products).filter(
      (product) => product.exhibitor_id === openProduct?.exhibitor_id && product.id !== openProduct?.id
    )
);
